import type { Novidade } from './tipos';

/** Ficha 2026-11-03: card da agenda com a cor de cada pessoa, igual à do Google. */
export const novidadeAgendaCores: Novidade = {
  id: '2026-11-03-agenda-cores',
  publicada_em: '2026-11-03',
  tipo: 'melhoria',
  modulo: 'agenda',
  permissao: 'agenda.ver',
  textos: {
    pt: {
      titulo: 'Cada pessoa com a sua cor na agenda',
      resumo: 'Vendo todas as agendas, cada agendamento e evento do Google sai na cor da pessoa dona da agenda, a mesma que ela usa no Google.',
      passos: [
        'Em CRM > Reuniões/Agenda ou em Agenda > Semana, Dia e Mês, escolha Todos os recursos no filtro: cada card aparece com o fundo e a borda na cor da pessoa. A legenda ao lado do filtro diz de quem é cada cor.',
        'Para usar a cor do Google, vá em Minha conta > Perfil > Google Agenda e clique em Reconectar uma vez. Quem nunca conectou, ao conectar, já traz a cor.',
        'Sem o Google, cada pessoa recebe uma cor diferente do sistema. Em Cadastros > Agenda > Profissionais e recursos você pode escolher outra.',
      ],
    },
    en: {
      titulo: 'Each person with their own color in the schedule',
      resumo: 'With all calendars in view, each appointment and Google event shows in the color its owner uses on Google.',
      passos: [
        'In CRM > Meetings/Calendar or in Schedule > Week, Day and Month, choose All resources in the filter: each card shows the background and border in the person\'s color. The legend next to the filter says whose color is whose.',
        'To use the Google color, go to My account > Profile > Google Calendar and click Reconnect once. Anyone connecting for the first time already brings the color.',
        'Without Google, each person gets a different system color. In Records > Schedule > Staff and resources you can choose another one.',
      ],
    },
    es: {
      titulo: 'Cada persona con su color en la agenda',
      resumo: 'Al ver todas las agendas, cada cita y evento de Google aparece en el color de la persona dueña de la agenda, el mismo que usa en Google.',
      passos: [
        'En CRM > Reuniones/Agenda o en Agenda > Semana, Día y Mes, elige Todos los recursos en el filtro: cada tarjeta aparece con el fondo y el borde en el color de la persona. La leyenda junto al filtro indica de quién es cada color.',
        'Para usar el color de Google, ve a Mi cuenta > Perfil > Google Calendar y haz clic en Reconectar una vez. Quien nunca se conectó ya trae el color al conectarse.',
        'Sin Google, cada persona recibe un color distinto del sistema. En Registros > Agenda > Profesionales y recursos puedes elegir otro.',
      ],
    },
  },
  treinamento: { curso: 'novidades' },
  imagens: ['/novidades/2026-11-03-agenda-cores/semana.webp', null, null],
  rota: '/crm/reunioes',
};
